import { useTranslations } from "../../hooks/useTranslations";
import { Permission } from "../../types";
import PermissionSelect from "./PermissionSelect";

interface Props {
  selectedPermissions: string[];
  disabledPermissions?: string[];
  onChange: (permissions: string[]) => void;
}

const ApplicationPermissions = ({
  selectedPermissions,
  disabledPermissions,
  onChange,
}: Props) => {
  const { i18n } = useTranslations();

  const accounting = {
    label: i18n.departments.accounting.title,
    permissions: [
      Permission.AccountingsRead,
      Permission.OpenItemsRead,
      Permission.InvoicePortalExecute,
      Permission.BusinessCheckExecute,
      Permission.TIBuchRead,
      Permission.MonatsdatenDataWrite,
      Permission.EndbestaendeWorksheetsWrite,
    ],
  };

  const joinHospitality = {
    label: i18n.departments.joinHospitality.title,
    permissions: [
      Permission.JoinHospitalityLevel1Read,
      Permission.JoinHospitalityLevel2Read,
    ],
  };

  const payroll = {
    label: i18n.departments.payroll.title,
    permissions: [
      Permission.HourRegistrationExecute,
      Permission.EmployeeRegistrationExecute,
      Permission.WageCostsRead,
    ],
  };

  const webMarketing = {
    label: i18n.departments.webMarketing.title,
    permissions: [Permission.AgreementsExecute, Permission.Dac7Write],
  };

  return (
    <PermissionSelect
      categories={[accounting, payroll, webMarketing, joinHospitality]}
      renderItem={(permission) => {
        const isSelected = selectedPermissions.includes(permission);
        const isDisabled = disabledPermissions?.includes(permission);
        return (
          <PermissionSelect.Item
            key={permission}
            permission={permission}
            status={
              isSelected ? "selected" : isDisabled ? "disabled" : "not_selected"
            }
            onClick={() =>
              onChange([
                ...selectedPermissions.filter((p) => p !== permission),
                ...(!isSelected ? [permission] : []),
              ])
            }
          />
        );
      }}
    />
  );
};

export default ApplicationPermissions;
